var _effectorFileName = "/builds/gmini/front-ui-kit/src/NodeMoreActionButton/NodeMoreActionButton.styled.ts";
import styled from 'styled-components';
import { Button } from '../Button/Button.styled';
export const NodeMoreActionButton = styled(Button)`
  height: 20px;
  width: 20px;
  background: inherit;
  ${props => !props.show && 'opacity: 0;'}
  ${props => !props.disabled && props.active && 'background: rgba(0, 10, 87, 0.07);'}

  path {
    ${props => !props.disabled && 'fill: #A2A3B7;'}
  }

  &:hover {
    ${props => !props.disabled && 'background: rgba(0, 10, 87, 0.07);'}
  }
`;
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 4px;
  min-width: 4px;
  height: 14px;
  min-height: 14px;
`;